import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import Application from "@cloudpivot/application/pc";
import { Dropdown, Modal, Input, Row, Col } from "@h3/antd-vue";
import { namespace } from "vuex-class";
import OAuthApi from "@/apis/oauth";
import env from "@/config/env";
import site from "@/config/site";
const icon = require("@/assets/icons/appicon.svg");
const WorkflowCenterModule = namespace("WorkflowCenter/WorkflowCenter");
const SystemModule = namespace("System/System");
let CommonHeader = class CommonHeader extends Vue {
    constructor() {
        super(...arguments);
        // 只有自维护的用户并且不是admin这个账户才能有修改密码入口 #39826
        this.isShowUpdatePwdBtn = true;
        // 用户信息
        this.userInfo = {};
        this.showModal = false;
        this.params = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.oldPwdErrTips = "";
        this.newPwdErrTips = "";
        this.surePwdErr = false;
    }
    get logo() {
        return site.logo;
    }
    get isShowToggle() {
        return this.$store.state.config.multiLanguageSwitch;
    }
    get isCloudPivot() {
        // 是否已打开内部维护组织开关
        return this.$store.state.config.cloudPivot;
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem("token");
    }
    created() {
        // 获取当前选中的菜单名称
        this.getUserInfo();
    }
    // 跳转到个人中心
    toUserInfo() {
        // window.location.href = '/user/info';
        this.$router.push("/user").catch((err) => {
            err;
        });
    }
    // 跳转后台管理
    toAdmin() {
        const token = localStorage.getItem("token");
        if (this.isDingTalk && token) {
            window.open(`${env.portalHost}/admin/?admin_token=${token}`, "_blank");
        }
        else {
            window.open(`${env.portalHost}/admin/`, "_blank");
        }
    }
    // 退出登录confirm
    logoutConfirm() {
        const vm = this;
        vm.$confirm({
            title: this.$t("languages.common.tip.sureToLogOut").toString(),
            okText: this.$t("languages.common.tip.confirm").toString(),
            cancelText: this.$t("languages.common.tip.cancel").toString(),
            onOk() {
                vm.logout();
            },
        });
    }
    // 退出登录
    logout() {
        const logoutIP = env.oauthHost;
        const redirectIP = env.redirectHost;
        const token = localStorage.getItem("token") || "";
        // window.location.href = `${logoutIP}/logout?redirect_uri=${redirectIP}/login&access_token=${token}`;
        OAuthApi.logout({
            redirect_uri: `${redirectIP}/login`,
            access_token: token,
        }).then((res) => {
            // console.log(res);
            localStorage.removeItem("token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("expireTime");
            sessionStorage.removeItem("user");
            this.$router.replace({ name: "login" });
        });
    }
    // 跳转到首页
    goHome() {
        const appCode = window.Environment ? window.Environment.appCode : null;
        if (appCode) {
            this.$router
                .push({
                name: "singleApp",
                params: {
                    appCode,
                },
            })
                .catch((err) => {
                err;
            });
        }
        else {
            this.$router.push({ name: "myUnfinishedWorkItem" }).catch((err) => {
                err;
            });
            // 如果回到首页, 重新调整顶部导航栏下的 slider
            this.$refs.applications.initSlider();
        }
    }
    openBlank() {
        var href = location.href;
        var iframeAction = href.match(/%26iframeAction%3Ddetail/g);
        if (Array.isArray(iframeAction) && iframeAction.length > 1) {
            for (let i = 0; i < iframeAction.length - 1; i++) {
                href = href.replace("%26iframeAction%3Ddetail", "");
            }
        }
        const url = `${href}${href.indexOf("?") > -1 ? "&" : "?"}access_token=${localStorage.getItem("token")}`;
        window.open(url, "_blank");
    }
    // 获取当前用户信息
    getUserInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield OAuthApi.getUserInfo();
            if (res.errcode === 0) {
                const info = res.data;
                this.userInfo = info;
                this.setUserId(info);
                this.isShowUpdatePwdBtn =
                    (res.data.relatedSyncType === "PUSH" ||
                        this.$store.state.config.loginType === 0 ||
                        this.$store.state.config.loginType === 2) &&
                        res.data.username !== "admin"; // admin这个账号 hide || 或者开启了账号密码登陆的时候
                sessionStorage.setItem("user", JSON.stringify(info));
                // 判断当前用户角色
                const isAppAdmin = info.permissions.includes("APP_MNG");
                const isSysAdmin = info.permissions.includes("SYS_MNG");
                const isRootAdmin = info.permissions.includes("ADMIN");
                const isAdmin = isAppAdmin || isSysAdmin || isRootAdmin;
                this.setIsAdmin(isAdmin);
                this.setRootAdmin(isRootAdmin);
                this.setAdmin(isSysAdmin || isRootAdmin);
                // 禁止无权限访问流程查询页面
                if (!isSysAdmin &&
                    !isRootAdmin &&
                    this.$route.name &&
                    ["queryInstance", "queryParticipantWorkItem"].includes(this.$route.name)) {
                    this.$router.replace({ name: "myUnfinishedWorkItem" });
                }
                // 禁止超管访问流程委托页面
                if (isRootAdmin &&
                    this.$route.name &&
                    ["delegationWorkflow"].includes(this.$route.name)) {
                    this.$router.replace({ name: "myUnfinishedWorkItem" });
                }
            }
        });
    }
    getDownloadUrl(refId) {
        let url = `${this.apiHost}/api/aliyun/download?refId=${refId}`;
        if (this.token) {
            url += "&access_token=" + this.token;
        }
        return url;
    }
    /**
     * 切换多语言
     */
    toggleLanguage() {
        if (this.$i18n.locale === "zh") {
            this.$i18n.locale = "en";
        }
        else {
            this.$i18n.locale = "zh";
        }
        this.$forceUpdate();
        localStorage.setItem("locale", this.$i18n.locale);
    }
    /*
     * 修改密码
     */
    changePwd() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.resetErrTips();
            if (!this.params.oldPwd) {
                this.oldPwdErrTips = this.$t("languages.common.oldPwdRequied").toString();
                return;
            }
            if (!this.params.newPwd) {
                this.newPwdErrTips = this.$t("languages.common.newPwdRequied").toString();
                return;
            }
            if (this.params.newPwd !== this.params.surePwd) {
                this.surePwdErr = true;
                this.newPwdErrTips = this.$t("languages.common.newPwdNotSame").toString();
                return;
            }
            const params = {
                username: this.userInfo.username,
                corpId: this.userInfo.corpId,
                oldPassword: this.params.oldPwd,
                newPassword: this.params.newPwd,
            };
            const res = yield OAuthApi.changePassword(params);
            if (res.errcode) {
                this.$message.error(res.errmsg);
                return;
            }
            this.$message.success(`${this.$t("languages.common.changePwdSuccess")}`);
            this.logout();
        });
    }
    /*
     * 重置密码错误提示
     */
    resetErrTips() {
        this.oldPwdErrTips = "";
        this.newPwdErrTips = "";
        this.surePwdErr = false;
    }
    cancel() {
        this.showModal = false;
        this.params = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.resetErrTips();
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAsideTitle")
], CommonHeader.prototype, "setAsideTitle", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setUserId")
], CommonHeader.prototype, "setUserId", void 0);
tslib_1.__decorate([
    SystemModule.State("isAdmin")
], CommonHeader.prototype, "isAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setIsAdmin")
], CommonHeader.prototype, "setIsAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setAdmin")
], CommonHeader.prototype, "setAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setRootAdmin")
], CommonHeader.prototype, "setRootAdmin", void 0);
CommonHeader = tslib_1.__decorate([
    Component({
        name: "common-header",
        components: {
            ADropdown: Dropdown,
            AModal: Modal,
            AInput: Input,
            ARow: Row,
            ACol: Col,
            ApplicationHeader: Application.ApplicationHeader,
        },
    })
], CommonHeader);
export default CommonHeader;
